import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Input, Table, Form, Select } from 'tdesign-react';
import { groupBy, maxBy } from 'lodash';
import { renderDateTime } from '@/utils/common';
import PermWrapper from '@/components/PermWrapper';
import ShadowCard from '@/components/ShadowCard';
import useTable from '@/hooks/useTable';
import { getPackageList } from '@/services/functionService';
import ModalForm from './ModalForm';
import PackageTable from './PackageTable';

const { FormItem } = Form;

const options = [
  {
    value: 'Java',
    label: 'Java',
  },
  {
    value: 'Python',
    label: 'Python',
  },
];

const packageOptions = [
  {
    value: 'Function',
    label: 'Function',
  },
  {
    value: 'Source',
    label: 'Source',
  },
  {
    value: 'Sink',
    label: 'Sink',
  },
];

export default function Body({ clusterName }) {
  const [formVisible, setFormVisible] = useState(false);

  const columns = [
    {
      title: '包类型',
      colKey: 'packageType',
      width: 140,
      sorter: true,
    },
    {
      title: '包名',
      colKey: 'packageName',
      sorter: true,
    },
    {
      title: '任务类型',
      colKey: 'functionRuntime',
      sorter: true,
      width: 120,
    },
    {
      width: 180,
      title: '最新上传时间',
      colKey: 'lastCreateTime',
      cell: renderDateTime,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <PackageTable
          clusterName={clusterName}
          doRefresh={doRefresh}
          row={row}
          options={options}
          packageOptions={packageOptions}
        />
      ),
      width: 150,
    },
  ];

  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getPackageList({
      clusterName,
      packageType: params.packageType,
      functionRuntime: params.functionRuntime,
      packageName: params.packageName,
    });
    const SEPARATOR = '|;;|';
    const groupData = groupBy(
      data,
      (item) =>
        `${item.functionRuntime}${SEPARATOR}${item.packageType}${SEPARATOR}${item.packageName}`,
    );
    const datas = [];
    Object.entries(groupData).forEach(([key, value]) => {
      const [functionRuntime, packageType, packageName] = key.split(SEPARATOR);
      datas.push({
        functionRuntime,
        packageName,
        packageType,
        lastCreateTime: maxBy(value, (item) => new Date(item.createTime)).createTime,
        versions: value,
      });
    });
    setData(datas);
  });

  const { config, setData, doSearch, doRefresh, header } = useTable({
    columns,
    search: (
      <>
        <FormItem name='packageType'>
          <Select options={packageOptions} placeholder='请选择包类型' clearable />
        </FormItem>
        <FormItem name='functionRuntime'>
          <Select options={options} placeholder='请选择任务类型' clearable />
        </FormItem>
        <FormItem name='packageName'>
          <Input placeholder='请输入包名称' clearable />
        </FormItem>
      </>
    ),
    onSearch: loadData,
    operators: (
      <PermWrapper resource='pulsar:function:packageManage:create'>
        <Button
          onClick={() => {
            setFormVisible(true);
          }}
        >
          包上传
        </Button>
      </PermWrapper>
    ),
  });

  useEffect(() => {
    if (clusterName) {
      doSearch();
    }
  }, [clusterName, doSearch]);

  const modalClose = (fresh) => {
    setFormVisible(false);
    if (fresh) {
      doRefresh();
    }
  };

  return (
    <Root>
      {header}
      <Table {...config} rowKey='packageName' />
      <ModalForm
        visible={formVisible}
        options={options}
        packageOptions={packageOptions}
        handleClose={modalClose}
      />
    </Root>
  );
}

const Root = styled(ShadowCard)`
  padding-right: 20px;
`;
